import { DISTRIBUTOR } from '../constants/distributor';

export const devIntroMochipayUrl = {
  [DISTRIBUTOR.MOCHIPAY]: 'https://intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.AUTOPASS]: 'https://autopass-intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.CATHAYMR]:
    'https://cathay-my-rewards-intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.CPCPAY]: 'https://cpcpay-intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.CITIMKT]:
    'https://citibank-marketplace-intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.LINE_BANK]:
    'https://line-bank-intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.IKNOW99]: 'https://iknow99-intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.AUTO_PARTNER]:
    'https://autopartner-intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.NPCPAY]: 'https://npc-intro-alpha-mochipay.pklotcorp.com',
  [DISTRIBUTOR.UAT]: 'https://autopass-intro-alpha-mochipay.pklotcorp.com',
};

export const prodIntroMochipayUrl = {
  [DISTRIBUTOR.MOCHIPAY]: 'https://intro.mochipay.xyz',
  [DISTRIBUTOR.AUTOPASS]: 'https://autopass-intro.mochipay.xyz',
  [DISTRIBUTOR.CATHAYMR]: 'https://cathay-my-rewards-intro.mochipay.xyz',
  [DISTRIBUTOR.CPCPAY]: 'https://cpcpay-intro.mochipay.xyz',
  [DISTRIBUTOR.CITIMKT]: 'https://citibank-marketplace-intro.mochipay.xyz',
  [DISTRIBUTOR.LINE_BANK]: 'https://line-bank-intro.mochipay.xyz',
  [DISTRIBUTOR.IKNOW99]: 'https://iknow99-intro.mochipay.xyz',
  [DISTRIBUTOR.AUTO_PARTNER]: 'https://autopartner-intro.mochipay.xyz',
  [DISTRIBUTOR.NPCPAY]: 'https://npc-intro.mochipay.xyz',
  [DISTRIBUTOR.UAT]: 'https://cathay-my-rewards-intro.mochipay.xyz',
};
